module.exports = __webpack_public_path__ + "img/uzmanposta-logo.fe7c6b96.svg";